import React from "react";
import {
  TestimonialCardGrid,
  TestimonialCards,
  TestimonialSectionWrapper,
  TestAttachImg,
  TestAttachImg4,
} from "./style";
import { Testimonial, Testimonial2, Testimonial3, Testimonial4,
  Testimonial1Attach,
  Testimonial2Attach,
  Testimonial3Attach,
  Testimonial4Attach,
 } from "../../shared/icons";

const TestimonialSection = () => {
  return (
    <TestimonialSectionWrapper>
      <h4>Recommended Reads</h4>
      <TestimonialCardGrid>
        <TestimonialCards target="_blank" rel="noopener noreferrer" href="https://impact.economist.com/perspectives/financial-services/digital-assets-new-alternative-institutional-investors">
          <div><img src={Testimonial} alt="" />
          <h4>Digital Assets: Market Dynamics, Opportunities and Challenges</h4>
          <h6>
          Guide for investors to navigate the maturing digital assets landscape.
          </h6></div>
          <TestAttachImg src={Testimonial1Attach} />
        </TestimonialCards>
        <TestimonialCards target="_blank" rel="noopener noreferrer" href="https://partners.wsj.com/coindesk/beyond-bitcoin/how-to-shape-a-new-asset-class/">
          <img src={Testimonial2} alt="" />
          <h4>Beyond Bitcoin: How to Shape A New Asset Class</h4>
          <h6>
          Article on how digital assets develop from a niche investment into a key asset class.
          </h6>
          <TestAttachImg src={Testimonial2Attach} />
        </TestimonialCards>
        <TestimonialCards target="_blank" rel="noopener noreferrer" href="https://www.oecd.org/content/dam/oecd/en/publications/reports/2022/12/environmental-impact-of-digital-assets_1fc184ca/8d834684-en.pdf">
          <img src={Testimonial3} alt="" />
          <h4>Demystifying cryptocurrency and digital assets</h4>
          <h6>
          Introduction to the mechanics of digital assets and its various categories.
          </h6>
          <TestAttachImg src={Testimonial4Attach} />
        </TestimonialCards>
        <TestimonialCards target="_blank" rel="noopener noreferrer" href="https://www.pwc.com/us/en/tech-effect/emerging-tech/understanding-cryptocurrency-digital-assets.html">
          <img src={Testimonial4} alt="" />
          <h4>Environmental impact of digital assets</h4>
          <h6>
          Overview of the environmental impact of crypto-assets and policy considerations.
          </h6>
          <TestAttachImg4 src={Testimonial3Attach} />
        </TestimonialCards>
      </TestimonialCardGrid>
    </TestimonialSectionWrapper>
  );
};

export default TestimonialSection;
